import { z } from "zod";
import { SelectComerOrigin } from "../types/comerOrigin";

export const zodComerOriginSchema = z.string({ invalid_type_error: 'common:text.required_field'}) satisfies z.ZodType<SelectComerOrigin>;